import { render, staticRenderFns } from "./IbxCheckboxList.vue?vue&type=template&id=14a9f2a6"
import script from "./IbxCheckboxList.vue?vue&type=script&lang=js"
export * from "./IbxCheckboxList.vue?vue&type=script&lang=js"
import style0 from "./IbxCheckboxList.vue?vue&type=style&index=0&id=14a9f2a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports